import { Box } from "@mui/material";
import styled from "styled-components/macro";
import { ReactComponent as VYRO } from "src/assets/images/tokens/VYRO.svg";
import { ReactComponent as EsVYRO } from "src/assets/images/tokens/esVYRO.svg";
import { ReactComponent as USDT } from "src/assets/images/tokens/USDT.svg";
import { ThemedText } from "src/theme/text";
import { Trans } from "@lingui/macro";
import { formatAmount2 } from "src/helpers/Helpers";
import { useGetVyroPrice } from "src/hooks/get_price_vyro";
import { useSelector } from "react-redux";
import { useMemo } from "react";
import { BN } from "src/utils/bn";
import {
  useBalance_VYRO,
  useBalance_esVYRO,
  useBalance_usdc,
} from "src/hooks/useQueryEarn";
import { ReactComponent as ADDtoken } from "src/assets/images/AddToken.svg";
import useAddTokenToMetamask from "src/hooks/useAddTokenToMetamask";
import { useWeb3Context } from "src/hooks";
import { addresses as ADDRESS } from "src/configs/constants";
const TokenListBox = styled(Box)`
  .balance {
    padding: 18px 8px 10px;
    border-bottom: 1px solid ${({ theme }) => theme.bg3};
  }
  .tokenItem {
    padding: 18px 8px 14px;
    :not(:last-child) {
      border-bottom: 1px solid ${({ theme }) => theme.bg3};
    }
  }
  .balance,
  .tokenItem {
    padding-left: 10px;
    padding-right: 6px;
  }
`;

export default function TokenList() {
  const VYROPrice = useGetVyroPrice();
  const VYROBalance = useBalance_VYRO();
  const esVYROBalance = useBalance_esVYRO();
  const usdcBalance = useBalance_usdc();
  const { addToken } = useAddTokenToMetamask();
  const { chainID } = useWeb3Context();
  const address_VYRO = ADDRESS[chainID].VYRO;
  const address_esVYRO = ADDRESS[chainID].esVYRO;
  const address_USDT = ADDRESS[chainID].USDT;
  const Add = (
    address: string,
    symbol: string,
    decimals: number,
    url: string
  ) => {
    addToken(address, symbol, decimals, url);
  };
  const tokensArr = useSelector((state: any) => {
    return state?.app?.tokensArr || [];
  });

  const totalAmount = useMemo(() => {
    if (
      VYROBalance == undefined ||
      esVYROBalance == undefined ||
      VYROPrice == undefined ||
      usdcBalance == undefined ||
      tokensArr.length == 0
    )
      return;
    const vyroAmount = VYROBalance.times(VYROPrice);
    const esVyroAmount = esVYROBalance.times(VYROPrice);
    const dlpAmount = tokensArr.reduce((pre, curr) => {
      const { dlpBalance, price } = curr;
      pre = pre.plus(BN(dlpBalance).times(price));
      return pre;
    }, BN(0));
    return dlpAmount
      .plus(vyroAmount)
      .plus(usdcBalance)
      .plus(esVyroAmount)
      .toFixed();
  }, [VYROBalance, esVYROBalance, VYROPrice, usdcBalance, tokensArr]);

  return (
    <TokenListBox className="tokenList">
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        className="balance"
      >
        <ThemedText.Text4Bold>
          <Trans>Wallet</Trans>
        </ThemedText.Text4Bold>
        <ThemedText.Text4Bold>
          ${formatAmount2(totalAmount, 2, true)}
        </ThemedText.Text4Bold>
      </Box>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        className="tokenItem"
      >
        <Box display="flex" alignItems="center">
          <VYRO width={48} height={48} />
          <ThemedText.Text9Bold ml="12px" mr="8px" fontSize={16}>
            VYRO
          </ThemedText.Text9Bold>
          <ADDtoken
            className="pointer"
            // onClick={() => {
            //   Add(
            //     address_VYRO,
            //     "VYRO",
            //     18,
            //     "https://app.pinnako.io/img/VYRO.svg"
            //   );
            // }}
          />
        </Box>
        <div className="text-right">
          <ThemedText.Text9Bold fontSize={16}>
            {formatAmount2(VYROBalance, 2, true)}
          </ThemedText.Text9Bold>
          <ThemedText.Text4 fontSize={14}>
            $
            {formatAmount2(
              VYROBalance?.times(VYROPrice ? VYROPrice : 1),
              2,
              true
            )}
          </ThemedText.Text4>
        </div>
      </Box>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        className="tokenItem"
      >
        <Box display="flex" alignItems="center">
          <EsVYRO width={48} height={48} />
          <ThemedText.Text9Bold ml="12px" mr="8px" fontSize={16}>
            esVYRO
          </ThemedText.Text9Bold>
          <ADDtoken
            className="pointer"
            // onClick={() => {
            //   Add(
            //     address_esVYRO,
            //     "esVYRO",
            //     18,
            //     "https://app.pinnako.io/img/esVYRO.svg"
            //   );
            // }}
          />
        </Box>
        <div className="text-right">
          <ThemedText.Text9Bold fontSize={16}>
            {formatAmount2(esVYROBalance, 2, true)}
          </ThemedText.Text9Bold>
          <ThemedText.Text4 fontSize={14}>
            $
            {formatAmount2(
              esVYROBalance?.times(VYROPrice ? VYROPrice : 1),
              2,
              true
            )}
          </ThemedText.Text4>
        </div>
      </Box>
      {/* {tokensArr.length > 0 ? (
        tokensArr.map((item, i) => (
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            className="tokenItem"
            key={i}
          >
            <Box display="flex" alignItems="center">
              <img src={item.icon} width={48} height={48} />
              <ThemedText.Text9Bold ml="12px" mr="8px" fontSize={16}>
                {item?.name}
              </ThemedText.Text9Bold>
              <ADDtoken
                className="pointer"
                // onClick={() => {
                //   Add(
                //     item.address,
                //     item.name,
                //     18,
                //     "https://app.pinnako.io/img/PLP.svg"
                //   );
                // }}
              />
            </Box>
            <div className="text-right">
              <ThemedText.Text9Bold fontSize={16}>
                {formatAmount2(item?.dlpBalance * 1, 2, true)}
              </ThemedText.Text9Bold>
              <ThemedText.Text4 fontSize={14}>
                ${formatAmount2(item?.dlpBalance * 1 * item?.price, 2, true)}
              </ThemedText.Text4>
            </div>
          </Box>
        ))
      ) : (
        <Skeleton width="100%" height={60} style={{ borderRadius: "10px" }} />
      )} */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        className="tokenItem"
      >
        <Box display="flex" alignItems="center">
          <USDT width={48} height={48} />
          <ThemedText.Text9Bold ml="12px" mr="8px" fontSize={16}>
            USDT
          </ThemedText.Text9Bold>
          <ADDtoken
            className="pointer"
            // onClick={() => {
            //   Add(
            //     address_USDT,
            //     "USDT",
            //     6,
            //     "https://app.pinnako.io/img/USDT.svg"
            //   );
            // }}
          />
        </Box>
        <div className="text-right">
          <ThemedText.Text9Bold fontSize={16}>
            {formatAmount2(usdcBalance, 2, true)}
          </ThemedText.Text9Bold>
          <ThemedText.Text4 fontSize={14}>
            ${formatAmount2(usdcBalance, 2, true)}
          </ThemedText.Text4>
        </div>
      </Box>
    </TokenListBox>
  );
}
